import { render, staticRenderFns } from "./masterdata-history.vue?vue&type=template&id=6c2c94da&scoped=true&lang=pug"
import script from "./masterdata-history.vue?vue&type=script&lang=ts"
export * from "./masterdata-history.vue?vue&type=script&lang=ts"
import style0 from "./masterdata-history.vue?vue&type=style&index=0&id=6c2c94da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c94da",
  null
  
)

export default component.exports